export default "<sh-richtext model=\"element.value\" autohide-toolbar=\"true\" placeholder=\"Enter text here\"></sh-richtext> ";